import { isNullOrUndefined } from "../../services/Validator";

export default function SystemNavigationItemIcon({ icon }) {
    // Used in SystemAppSideBarNavigationItem to display
    // collapsed nav element

    // BUILD
    if (isNullOrUndefined(icon))
        return null
    return (
        <i className="material-icons text-[20px]">
            {icon}
        </i>
    );
}
